import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LanguageClasses: React.FC = () => {
  
  const categories = [
    {
      title: 'JLPT Preparation',
      items: [
        { name: 'N5 & N4 (Beginner)', path: '/language-classes/beginner' },
        { name: 'N3 (Intermediate)', path: '/language-classes/intermediate' },
        { name: 'N2 & N1 (Advanced)', path: '/language-classes/advanced' },
      ]
    },
    {
      title: 'Special Courses',
      items: [
        { name: 'Business Japanese', path: '/language-classes/business' },
        { name: 'Conversational Japanese', path: '/language-classes/conversational' },
        { name: 'Kanji Mastery', path: '/language-classes/kanji' },
      ]
    },
    {
      title: 'Study Materials',
      items: [
        { name: 'Textbooks', path: '/language-classes/textbooks' },
        { name: 'Practice Tests', path: '/language-classes/practice-tests' },
        { name: 'Online Resources', path: '/language-classes/online-resources' },
      ]
    }
  ];

  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
            Japanese Language Classes
          </h1>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            Master Japanese with our comprehensive language programs designed for all levels and goals.
            From JLPT preparation to specialized business courses, we have everything you need to succeed.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={category.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="glass-dark p-6 rounded-xl"
            >
              <h2 className="text-2xl font-semibold mb-6 text-primary">{category.title}</h2>
              <ul className="space-y-4">
                {category.items.map((item) => (
                  <motion.li 
                    key={item.name}
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <Link 
                      to={item.path}
                      className="flex items-center text-slate-200 hover:text-primary transition-colors duration-200"
                    >
                      <span className="mr-2">→</span>
                      <span>{item.name}</span>
                    </Link>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-16 glass-dark p-8 rounded-xl text-center"
        >
          <h2 className="text-2xl font-semibold mb-4 text-primary">Ready to Start Your Japanese Journey?</h2>
          <p className="text-slate-300 mb-6">
            Contact us today to find the perfect course for your language learning goals.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-6 py-3 rounded-lg bg-gradient-to-r from-primary to-secondary text-white font-semibold transition-all hover:scale-105"
          >
            Contact Us
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default LanguageClasses; 